import { useMemo } from "react";
import { Column } from "react-table";
import { usePrograms } from "@refund/register-fixed-discount-rules/programs/hooks";
import { IProgram } from "@refund/register-fixed-discount-rules/programs/contracts";
import { Title, Link } from "@funcional/react-ui";
import { IntlEnum, IntlDateTime } from "@funcional/react-intl-ui";
import { useI18n } from "@common/helpers";
import {
  DefaultColumnFilter,
  GridView,
} from "@funcional/react-table-ui";

export default function ListProgramPageToTransactions() {
  const { intlEnum } = useI18n();

  const columns: Column<IProgram>[] = useMemo(
    () => [
      {
        Header: "Código",
        accessor: "code",
        Filter: DefaultColumnFilter,
        Cell: ({ value, row }) => (
          <Link to={`/refund/transactions/programs/${row?.original.id}/${value}`}>{value}</Link>
        ),
      },
      { Header: "Nome", accessor: "name" },
      {
        Header: "Tipo",
        accessor: "type",
        Cell: ({ value }) => <IntlEnum name="program_type" value={value} />,
      },

      {
        Header: "Política Cadastral",
        accessor: "registrationPolicy",
        Cell: ({ value }) => {
          if (!value) {
            return <>Nenhuma</>;
          }
          return value.description;
        },
      },
      {
        Header: "Início da vigência",
        accessor: "effectiveSince",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
      {
        Header: "Fim da vigência",
        accessor: "effectiveUntil",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
    ],
    [intlEnum]
  );

  return (
    <>
      <div className="flex items-center w-full mb-4">
        <div className="flex-1">
          <Title marginBottom={0}>Programas</Title>
          <span>
            Selecione o programa para visualizar as transações
          </span>
        </div>
      </div>
      <hr className="mb-2" />

      <GridView<IProgram>
        paginationType="cursor"
        accessControlResourceName="programs"
        columns={columns}
        hook={usePrograms}
      />
    </>
  );
}
